export default __webpack_public_path__ + "static/media/The Tiger's Will.9e010935.jpg";